/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Controllers.Splash = class Splash {
  constructor(el) {
    this.startProgressButton = this.startProgressButton.bind(this);
    this.updateButtonAndTooltip = this.updateButtonAndTooltip.bind(this);
    this._allFieldsValid = this._allFieldsValid.bind(this);
    this.el = el;
    this.view = new Buyapowa.Views.Splash(this.el, this);
    this.pb = new Buyapowa.Helpers.ProgressButton(this.el.find('button.splash'));
    this.view.onKeyPressed(this.updateButtonAndTooltip);
    this.view.onButtonClick(this.startProgressButton);
    this.updateButtonAndTooltip();
  }

  startProgressButton() {
    return this.pb.started(this.view.buttonProgressText());
  }

  updateButtonAndTooltip() {
    if (this._allFieldsValid()) {
      this.view.enableButton();
      return this.view.hideTooltip();
    } else {
      return this.view.disableButton();
    }
  }

  _allFieldsValid() {
    const fields = ['termsOptIn', 'emailComplianceOptIn', 'marketingOptIn'];
    for (var i of Array.from(fields)) {
      if (!this.view[`${i}Valid`]()) { return false; }
    }

    return true;
  }
};
